export function colorVariables(i) {
  var colors = {
    'pale-yellow': '#FFFCBF',
    'pale-yellow-light': '#FFFCEC',
    'city': '#12A900',
    'city-light': '#EFFFED',
    'county': '#FF9400',
    'county-light': '#FFF5D1',
    'state': '#0012e3',
    'state-light': '#EAF7FF',
    'state-senate': '#1d98ff',
    'fed': '#EC0000',
    'fed-light': '#FFCBBB',
  };
  return colors[i];
}
